import { getApiErrorMessage } from 'src/utils/errorHandler';

export const loadData = async (
  fetchFunction: (...args: any[]) => Promise<void>,
  showSnackbar: (message: string, severity: 'error' | 'success') => void,
  ...args: any[]
) => {
  try {
    await fetchFunction(...args);
  } catch (error) {
    const errorMessage = await getApiErrorMessage(error);
    showSnackbar(errorMessage, 'error');
  }
};
